/**
 * @generated SignedSource<<3a943c7c7937969074720836ae8ed31d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type LinkedImageItem_image$data = {
  readonly id: string;
  readonly " $fragmentSpreads": FragmentRefs<"Image_image">;
  readonly " $fragmentType": "LinkedImageItem_image";
};
export type LinkedImageItem_image$key = {
  readonly " $data"?: LinkedImageItem_image$data;
  readonly " $fragmentSpreads": FragmentRefs<"LinkedImageItem_image">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "LinkedImageItem_image",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "Image_image"
    }
  ],
  "type": "Image",
  "abstractKey": null
};

(node as any).hash = "fe465bfc55addaa705e0e48d17d8c2fa";

export default node;
